import { VisitsQuestionnaireDto, VisitDto } from '../../types/visits';
import httpRequest from '../httpRequest';

const baseURL = process.env.REACT_APP_GW_API_URL;

const visitsAPI = {
  createVisit: async (property_id: string, body: Omit<VisitDto, 'id'>) => {
    const { data } = await httpRequest<VisitDto>({
      baseURL: baseURL,
      url: `/dalgona/visits`,
      method: 'POST',
      data: { ...body, property_id: parseInt(property_id) },
    });

    return data;
  },
  getVisitsQuestionnaire: async (visit_id: string) => {
    const { data } = await httpRequest<VisitsQuestionnaireDto>({
      baseURL: baseURL,
      url: `/dalgona/visits/${visit_id}`,
      method: 'GET',
    });

    return data;
  },
  putVisitsQuestionnaire: async (
    visit_id: string,
    body: VisitsQuestionnaireDto,
  ) => {
    const { data } = await httpRequest<VisitsQuestionnaireDto>({
      baseURL: baseURL,
      url: `/dalgona/visits/${visit_id}`,
      method: 'PUT',
      data: body,
    });

    return data;
  },
};

export default visitsAPI;
